import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useAuth } from '../contexts/AuthContext';

const PaymentRecovery = () => {
  const [pendingOrders, setPendingOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { currentUser } = useAuth();

  useEffect(() => {
    const findPendingOrders = () => {
      const orders = [];
      
      // Check localStorage for pending orders
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key.startsWith('pendingOrder_')) {
          try {
            const orderData = JSON.parse(localStorage.getItem(key));
            const transactionId = key.replace('pendingOrder_', '');
            orders.push({
              transactionId,
              ...orderData,
              storageKey: key
            });
          } catch (e) {
            console.error('Failed to parse pending order:', e);
          }
        }
      }
      
      // Sort by creation date (newest first)
      orders.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      
      setPendingOrders(orders);
      setLoading(false);
    };

    findPendingOrders();
  }, []);

  const completeOrder = (order) => {
    // Navigate to order confirmation with the pending order data
    const params = new URLSearchParams({
      transId: order.transactionId,
      statusId: '2',
      status: 'Paid',
      amount: order.totalPrice?.toString() || '0',
      recovery: 'true'
    });
    
    // Store the order data for the confirmation page to use
    sessionStorage.setItem('recoveryOrderData', JSON.stringify(order));
    
    navigate(`/order-confirmation?${params.toString()}`);
  };

  const clearPendingOrder = (storageKey) => {
    localStorage.removeItem(storageKey);
    setPendingOrders(prev => prev.filter(order => order.storageKey !== storageKey));
  };

  if (!currentUser) {
    return (
      <div>
        <Header />
        <div style={{ padding: '40px', textAlign: 'center' }}>
          <h2>Please log in to view your pending orders</h2>
          <button onClick={() => navigate('/login')} style={{ padding: '10px 20px', margin: '20px' }}>
            Login
          </button>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div>
      <Header />
      <div style={{ padding: '40px', maxWidth: '800px', margin: '0 auto' }}>
        <h1>Payment Recovery</h1>
        <p>If you completed a payment but didn't receive a receipt, you can recover your order here.</p>
        
        {loading ? (
          <div>Loading...</div>
        ) : pendingOrders.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <h3>No pending orders found</h3>
            <p>All your orders appear to be completed successfully.</p>
            <button onClick={() => navigate('/shops')} style={{ padding: '10px 20px', background: '#007cba', color: 'white', border: 'none', borderRadius: '4px' }}>
              Continue Shopping
            </button>
          </div>
        ) : (
          <div>
            <h3>Pending Orders ({pendingOrders.length})</h3>
            {pendingOrders.map((order, index) => (
              <div key={index} style={{ 
                border: '1px solid #ddd', 
                borderRadius: '8px', 
                padding: '20px', 
                marginBottom: '20px',
                background: '#f9f9f9'
              }}>
                <div style={{ marginBottom: '10px' }}>
                  <strong>Transaction ID:</strong> {order.transactionId}
                </div>
                <div style={{ marginBottom: '10px' }}>
                  <strong>Created:</strong> {new Date(order.createdAt).toLocaleString()}
                </div>
                <div style={{ marginBottom: '10px' }}>
                  <strong>Total:</strong> QAR {order.totalPrice || 0}
                </div>
                <div style={{ marginBottom: '10px' }}>
                  <strong>Items:</strong> {order.cartItems?.length || 0} item(s)
                </div>
                
                {order.cartItems && order.cartItems.length > 0 && (
                  <details style={{ marginBottom: '15px' }}>
                    <summary style={{ cursor: 'pointer', fontWeight: 'bold' }}>View Items</summary>
                    <ul style={{ marginTop: '10px' }}>
                      {order.cartItems.map((item, idx) => (
                        <li key={idx}>
                          {item.name} - {item.selectedWeight?.label || item.weight || ''} 
                          {item.selectedBeanType ? ` (${item.selectedBeanType})` : ''} 
                          x{item.quantity} - QAR {item.price}
                        </li>
                      ))}
                    </ul>
                  </details>
                )}
                
                <div style={{ display: 'flex', gap: '10px' }}>
                  <button 
                    onClick={() => completeOrder(order)}
                    style={{ 
                      background: '#28a745', 
                      color: 'white', 
                      border: 'none', 
                      padding: '10px 20px', 
                      borderRadius: '4px', 
                      cursor: 'pointer' 
                    }}
                  >
                    Complete This Order
                  </button>
                  <button 
                    onClick={() => clearPendingOrder(order.storageKey)}
                    style={{ 
                      background: '#dc3545', 
                      color: 'white', 
                      border: 'none', 
                      padding: '10px 20px', 
                      borderRadius: '4px', 
                      cursor: 'pointer' 
                    }}
                  >
                    Remove
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default PaymentRecovery; 